module.exports = __webpack_public_path__ + "static/media/poppins-v15-latin-800.c04b2333.eot";